import { createFeatureSelector, createSelector } from '@ngrx/store'
import {
  PROFILE_ITEM_ACTIVITIES_FEATURE_KEY,
  ProfileItemActivitiesState,
  activitiesAdapter,
} from './profile-item-activities.reducer'
import * as SelectedItemSelectors from 'libs/gb-front/selected-item/data-access/src/lib/+state/selected-item.selectors'

// Lookup the 'ProfileItemActivities' feature state managed by NgRx
export const getProfileItemActivitiesState = createFeatureSelector<ProfileItemActivitiesState>(
  PROFILE_ITEM_ACTIVITIES_FEATURE_KEY,
)

const { selectAll, selectEntities } = activitiesAdapter.getSelectors()

export const getProfileItemActivitiesLoaded = createSelector(
  getProfileItemActivitiesState,
  (state: ProfileItemActivitiesState) => state.loaded,
)

export const getActivitiesError = createSelector(
  getProfileItemActivitiesState,
  (state: ProfileItemActivitiesState) => state.error,
)

export const getAllProfileItemActivities = createSelector(
  getProfileItemActivitiesState,
  (state: ProfileItemActivitiesState) => selectAll(state),
)

export const getActivitiesEntities = createSelector(
  getProfileItemActivitiesState,
  (state: ProfileItemActivitiesState) => selectEntities(state),
)

export const getSelectedId = createSelector(
  getProfileItemActivitiesState,
  (state: ProfileItemActivitiesState) => state.selectedId,
)

export const getSelected = createSelector(getActivitiesEntities, getSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)

export const getPurchasedRaffleTicketsByProfile = createSelector(getSelected, (entity) =>
  entity && entity.raffle_summary ? entity.raffle_summary.tickets_purchased : 0,
)

export const getPendingRaffleTicketsByProfile = createSelector(getSelected, (entity) =>
  entity && entity.raffle_summary ? entity.raffle_summary.pending_tickets_purchased : 0,
)

export const getRemainingRaffleTicketsByProfile = createSelector(
  getSelected,
  SelectedItemSelectors.getSelectedRaffleItem,
  (entity, currentRaffleItem) => {
    if (!currentRaffleItem?.tickets_remaining) return 0
    if (entity?.raffle_summary) return entity.raffle_summary.tickets_remaining

    // if profile has no previous purchases of item
    return currentRaffleItem.max_tickets_per_person > currentRaffleItem.tickets_remaining
      ? // return tickets remaining if less than max tickets pp
        currentRaffleItem.tickets_remaining
      : // return max tickets pp
        currentRaffleItem.max_tickets_per_person
  },
)

export const getPurchasedUnitsByProfile = createSelector(getSelected, (entity) =>
  entity && entity.purchase_summary ? entity.purchase_summary.units_purchased : 0,
)

export const getPendingUnitsByProfile = createSelector(getSelected, (entity) =>
  entity && entity.purchase_summary ? entity.purchase_summary.pending_purchases : 0,
)

export const getRemainingPurchaseUnitsByProfile = createSelector(
  getSelected,
  SelectedItemSelectors.getSelectedPurchaseItem,
  (entity, currentPurchaseItem) => {
    if (!currentPurchaseItem?.units_remaining) return 0
    if (entity?.purchase_summary) return entity.purchase_summary.units_remaining

    // if profile has no previous purchases of item
    return currentPurchaseItem.units_per_person > currentPurchaseItem.units_remaining
      ? // return units remaining if less than max units pp
        currentPurchaseItem.units_remaining
      : // return max units pp
        currentPurchaseItem.units_per_person
  },
)
